export class WidgetDetailParam {
    CustomerId:string;
    FacilityId: string;
    PageNumber : number;
    PageSize : number;
    WidgetType : string;
    StartDate: Date;
    EndDate: Date;   
    ProductivityInput: number;
    DesiredHourlyUnits: number; 
    TaskRefNumber : string; 
    ReportDate: Date;
    StartHours: number;
    EndHours: number;
}


// WEBPACK FOOTER //
// ./src/app/models/WidgetDetailParam.ts